import { ILocationsStatistic, IVoicePlatformAccessStatistic } from '../model';

const nexParkKey = (customerId: number): string => `nexPark_stats_${customerId}`;

const nexResponseKey = (customerId: number, regionId: number): string => `nexResponse_stats_${customerId}_${regionId}`;

const voicePlatformKey = (customerId: number): string => `voicePlatform_stats_${customerId}`;

const read = (cacheKey: string): ILocationsStatistic | undefined => {
  try {
    const raw = sessionStorage.getItem(cacheKey);
    return raw ? (JSON.parse(raw) as ILocationsStatistic) : undefined;
  } catch {
    return undefined;
  }
};

const write = (cacheKey: string, value: ILocationsStatistic): void => {
  try {
    sessionStorage.setItem(cacheKey, JSON.stringify(value));
  } catch {
    // ignore storage write errors (e.g., quota exceeded / storage disabled)
  }
};

const readVoicePlatform = (cacheKey: string): IVoicePlatformAccessStatistic | undefined => {
  try {
    const raw = sessionStorage.getItem(cacheKey);
    return raw ? (JSON.parse(raw) as IVoicePlatformAccessStatistic) : undefined;
  } catch {
    return undefined;
  }
};

const writeVoicePlatform = (cacheKey: string, value: IVoicePlatformAccessStatistic): void => {
  try {
    sessionStorage.setItem(cacheKey, JSON.stringify(value));
  } catch {
    // ignore storage write errors (e.g., quota exceeded / storage disabled)
  }
};

export const billingCache = {
  nexParkKey,
  nexResponseKey,
  voicePlatformKey,
  read,
  write,
  readVoicePlatform,
  writeVoicePlatform,
};
